module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "current-cycle"
  }, [_c('coming-soon-modal', {
    attrs: {
      "dialog": _vm.dialog
    },
    on: {
      "update:dialog": function($event) {
        _vm.dialog = $event
      }
    }
  }), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    staticClass: "left-align-tile"
  }, [_c('v-list-tile-action', {
    staticClass: "status"
  }, [_c('v-icon', {
    attrs: {
      "color": _vm.$ponceConfig.checkStatus(_vm.device.Event ? _vm.device.Event.State.value : _vm.STATES.OFF)
    }
  }, [_vm._v("trip_origin")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "device-state"
  }, [_vm._v(_vm._s(_vm.device.Event ? _vm.state : _vm.STATES_LABELS[_vm.STATES.OFF]))]), _vm._v(" "), (_vm.device.Event) ? _c('v-list-tile-sub-title', [_vm._v("Desde " + _vm._s(_vm.firstStatePoint ? _vm.convertDate(_vm.firstStatePoint.dateTime) : ''))]) : _c('v-list-tile-sub-title', [_vm._v("Sin datos")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.device.Event && _vm.device.Event.State.value == _vm.STATES.IRRIGATING) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "grid",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "tile": "",
      "flat": ""
    }
  }, [_c('v-carousel', {
    ref: "carousel-1",
    attrs: {
      "id": "carousel-current-cycle",
      "cycle": false,
      "hide-controls": true,
      "height": "100%"
    }
  }, [_c('v-carousel-item', [_c('div', {
    on: {
      "click": function($event) {
        return _vm.changeSlide('next', 1)
      }
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center"
  }, [_vm._v("\n                LAMINA\n                "), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-icon', _vm._g(_vm._b({
          staticClass: "ml-1 mb-1.5",
          attrs: {
            "color": "#00202F",
            "small": "",
            "mx-3": ""
          },
          on: {
            "click": function($event) {
              return _vm.handleTooltip($event)
            }
          }
        }, 'v-icon', attrs, false), on), [_vm._v("error_outline")])]
      }
    }], null, false, 1776539843)
  }, [_vm._v(" "), _c('span', [_vm._v("Milímetros promedio aplicados con la velocidad actual")])])], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "value justify-center"
  }, [_vm._v(_vm._s(_vm.device.Event.sheet || '-')), _c('strong', {
    staticClass: "padding-space-text"
  }, [_vm._v("mm.")])])], 1)]), _vm._v(" "), _c('v-carousel-item', [_c('div', {
    on: {
      "click": function($event) {
        return _vm.changeSlide('previous', 1)
      }
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center"
  }, [_vm._v("\n                SENTIDO DE GIRO\n                "), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-icon', _vm._g(_vm._b({
          staticClass: "ml-1 mb-1.5",
          attrs: {
            "color": "#00202F",
            "small": "",
            "mx-3": ""
          },
          on: {
            "click": function($event) {
              return _vm.handleTooltip($event)
            }
          }
        }, 'v-icon', attrs, false), on), [_vm._v("error_outline")])]
      }
    }], null, false, 1776539843)
  }, [_vm._v(" "), _c('span', [_vm._v("Dirección de movimiento")])])], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "value justify-center"
  }, [_vm._v(_vm._s(_vm.device.Event.direction == 'F' ? 'Horario' : 'Antihorario'))])], 1)])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "grid",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "tile": "",
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center"
  }, [_vm._v("PRESIÓN")]), _vm._v(" "), _c('v-card-title', {
    staticClass: "value justify-center"
  }, [_vm._v(_vm._s(_vm.device.Event.pressure ? _vm.device.Event.pressure : '-')), _c('strong', {
    staticClass: "padding-space-text"
  }, [_vm._v("bar")])])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "grid",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "tile": "",
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center"
  }, [_vm._v("VELOCIDAD ACTUAL")]), _vm._v(" "), _c('v-card-title', {
    staticClass: "value justify-center"
  }, [_vm._v(_vm._s(_vm.currentSpeed ? _vm.currentSpeed.toFixed(2) : '-')), _c('strong', {
    staticClass: "padding-space-text"
  }, [_vm._v("m/h")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "grid",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "tile": "",
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center"
  }, [_vm._v("TIEMPO REGADO")]), _vm._v(" "), _c('v-card-title', {
    staticClass: "value justify-center"
  }, [_vm._v(_vm._s(_vm.irrigatedTime ? _vm.irrigatedTime.toFixed(2) : '-')), _c('strong', {
    staticClass: "padding-space-text"
  }, [_vm._v("hs")])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "detail-btn-div",
    attrs: {
      "xs-12": ""
    }
  }, [_c('v-btn', {
    staticClass: "detail-btn",
    attrs: {
      "block": "",
      "color": "info"
    },
    on: {
      "click": _vm.comingsoon
    }
  }, [_vm._v("Detalle del ciclo")])], 1), _vm._v(" "), _c('app-snackbar', {
    attrs: {
      "text": _vm.snackBarText,
      "show": _vm.snackbar,
      "color": _vm.snackbarColor,
      "timeOut": _vm.timeOut
    },
    on: {
      "update:show": function($event) {
        _vm.snackbar = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29bf2626","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Device/Item/CurrentCycle.vue
// module id = 629
// module chunks = 1 3